import { connect } from 'react-redux';

import { trackInteraction } from '../../helpers/tracking';
import { getGTAGRgpdOptions } from '../../selectors/rgpd';

const trackEvent = (event) => () => trackInteraction(event);

export const withTrackingEvent = connect(
  (state) => ({
    track: getGTAGRgpdOptions(state) ? trackEvent : () => () => null,
  }),
  {}
);
